import React, { ReactElement } from "react";
import { GQLPosts } from "@gql/types/gql";
import Image from "next/legacy/image";
import Link from "@components/shared/linkNoPrefetch";
import styles from "./style.module.scss";
import { extractExcerptFromBody } from "@lib/sharedUtils";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
export default function LastArticles({
    lastArticles,
}: {
    lastArticles: GQLPosts[];
}): ReactElement {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <section className="lg:my-20 my-14 flex lg:flex-row flex-col   gap-11">
            <div className=" sm:px-9 px-5 py-8 bg-[#F2F8FF] sm:max-w-[636px]  mx-auto lg:mx-0 relative ">
                <div className="relative sm:w-[562px] sm:h-[358px] w-[290px] h-[161px]">
                    <Image
                        src={lastArticles[0].image?.fullPath as string}
                        layout="fill"
                        alt={lastArticles[0].title as string}
                        priority={true}
                        sizes="(min-width: 1024px) 100vw, 50vw"
                    />
                </div>
                <h2 className=" mt-4 font-bold text-lg ">
                    {lastArticles[0].title as string}
                </h2>
                <section
                    className=" mt-3 "
                    dangerouslySetInnerHTML={{
                        __html:
                            lastArticles[0].excerpt ??
                            `${
                                extractExcerptFromBody(
                                    lastArticles?.at(0)?.body as string,
                                    140,
                                ) as string
                            }.....`,
                    }}
                />
                <Link
                    href={lastArticles[0].url?.url as string}
                    className={`mt-2 block  w-fit ${styles.readMoreLink}`}
                >
                    {translate(translations, "several_general_readMoreButton")}
                </Link>
            </div>
            <div className=" sm:w-[436px] w-full mx-auto lg:mx-0">
                <div className="  border-b-4 border-[#1693F0] pb-5  lg:text-2xl text-xl font-bold text-[#1693F0]">
                    {translate(
                        translations,
                        "several_blogPage_lastArticlesWord",
                    )}
                </div>
                <div className="">
                    {lastArticles.slice(1).map((post) => (
                        <div
                            className={`flex sm:flex-row cursor-pointer border-b last-of-type:border-b-0 py-7 gap-4 ${styles["hoverStyle"]} relative`}
                            key={post.id}
                        >
                            <div className="relative min-w-[155px] w-[155px]   h-[99px] ">
                                <Image
                                    src={post.image?.fullPath as string}
                                    alt={post.title as string}
                                    priority={true}
                                    width={155}
                                    height={99}
                                    sizes="(min-width: 320px) 33vw"
                                />
                            </div>
                            <div className=" flex flex-col justify-between ">
                                <p className="max-w-[257px]  sm:font-bold font-semibold sm:text-base text-sm">
                                    {post.title}
                                </p>
                                <Link
                                    href={post.url?.url as string}
                                    key={post.id}
                                    className={`${styles["overlayLink"]}   block w-fit sm:text-base text-sm `}
                                >
                                    {translate(
                                        translations,
                                        "several_general_readMoreButton",
                                    )}
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
